import getBasePath from '../../../../common/functions/api-resource';
import resourceBuilder from '../../../../common/functions/metadados-resource-builder';

const basePath = getBasePath('orcamento', 'orcamento');

const orcamentoActions = {
  buscarOrcamento: { methods: 'GET', url: `${basePath}/carregamento/{idOrcamento}` },
};

export default resource => resource(`${basePath}`, {}, orcamentoActions);

export const buscarTiposVerbaOrcamento = (parametros, resource) =>
  resourceBuilder.buildGET(resource, basePath, 'listagem/tipo_verba', parametros).doGet();

export const buscaOrcamentos = (parametros, resource) =>
  resourceBuilder.buildGET(resource, basePath, 'listagem/tipo_verba/orcamentos', parametros).doGet();



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/orcamento-listagem.js